import useMemoWithOptions from './useMemoWithOptions';

const useDeepCompareMemo = <T>(callback: () => T, dependencies: Array<any>): T =>
    useMemoWithOptions<T>(
        callback,
        dependencies.map((dependency) => ({ value: dependency, type: 'deep' })),
    );

export default useDeepCompareMemo;
